import React from 'react';
import Helmet from '../components/Helmet'
import Section from '../components/Section';
import Carousel from '../components/Carousel';
import Button from '../components/Button';

import image from './technika.jpg';
import carousel1 from '../images/carousel/technika/tech1.jpg';
import carousel2 from '../images/carousel/technika/tech2.jpg';
import carousel3 from '../images/carousel/technika/tech3.jpg';
import carousel4 from '../images/carousel/technika/tech4.jpg';
import carousel5 from '../images/carousel/technika/tech5.jpg';
import carousel6 from '../images/carousel/technika/tech6.jpg';
import carousel7 from '../images/carousel/technika/tech7.jpg';
import carousel8 from '../images/carousel/technika/tech8.jpg';
import carousel9 from '../images/carousel/technika/tech9.jpg';
import carousel10 from '../images/carousel/technika/tech10.jpg';
import carousel11 from '../images/carousel/technika/tech11.jpg';
import carousel12 from '../images/carousel/technika/tech12.jpg';
import carousel13 from '../images/carousel/technika/tech13.jpg';
import carousel14 from '../images/carousel/technika/tech14.jpg';
import carousel15 from '../images/carousel/technika/tech15.jpg';
import carousel16 from '../images/carousel/technika/tech16.jpg';
import carousel17 from '../images/carousel/technika/tech17.jpg';
import carousel18 from '../images/carousel/technika/tech18.jpg';
import carousel19 from '../images/carousel/technika/tech19.jpg';
import carousel20 from '../images/carousel/technika/tech20.jpg';
import carousel21 from '../images/carousel/technika/tech21.jpg';
import carousel22 from '../images/carousel/technika/tech22.jpg';
import carousel23 from '../images/carousel/technika/tech23.jpg';
import carousel24 from '../images/carousel/technika/tech24.jpg';
import carousel25 from '../images/carousel/technika/tech25.jpg';
import carousel26 from '../images/carousel/technika/tech26.jpg';
import carousel27 from '../images/carousel/technika/tech27.jpg';


const images = [
  { resolutions: { src: carousel1 }}, { resolutions: { src: carousel2 }},
  { resolutions: { src: carousel3 }}, { resolutions: { src: carousel4 }},
  { resolutions: { src: carousel5 }}, { resolutions: { src: carousel6 }},
  { resolutions: { src: carousel7 }}, { resolutions: { src: carousel8 }},
  { resolutions: { src: carousel9 }}, { resolutions: { src: carousel10 }},
  { resolutions: { src: carousel11 }}, { resolutions: { src: carousel12 }},
  { resolutions: { src: carousel13 }}, { resolutions: { src: carousel14 }},
  { resolutions: { src: carousel15 }}, { resolutions: { src: carousel16 }},
  { resolutions: { src: carousel17 }}, { resolutions: { src: carousel18 }},
  { resolutions: { src: carousel19 }}, { resolutions: { src: carousel20 }},
  { resolutions: { src: carousel21 }}, { resolutions: { src: carousel22 }},
  { resolutions: { src: carousel23 }}, { resolutions: { src: carousel24 }},
  { resolutions: { src: carousel25 }}, { resolutions: { src: carousel26 }},
  { resolutions: { src: carousel27 }}]

const text = `<p><strong>CustomArt</strong> zapewnia również kompleksową obsługę techniczną, pozwalającą obsłużyć każdy swój produkt artystyczny oraz współpracuje z renomowanymi podwykonawcami techniki estradowej, co pozwala zrealizować profesjonalnie praktycznie każde wydarzenie.</p>`
const seo = 'CustomArt zapewnia kompleksową obsługę techniczną, pozwalającą obsłużyć każdy swój produkt artystyczny oraz współpracuje z renomowanymi podwykonawcami techniki estradowej, co pozwala zrealizować profesjonalnie praktycznie każde wydarzenie.'

const Tech = (props) => {
  return (
    <div>
      <Helmet title="Technika estradowa">
        <meta type="description" content={seo} />
      </Helmet>
      <Section
        isFirstSection
        title="TECHNIKA ESTRADOWA"
        background={image}
        subtitle={text}
      />
      <div className="section__container" style={{ padding: '50px 15px' }}>
      <p>W ramach podstawowej obsługi oferujemy podesty sceniczne w różnych wariantach obicia, pełne nagłośnienie koncertowe zarówno dla DJ-ów, jak i rozbudowanych zespołów, oświetlenie koncertowe oraz architektoniczne. Możemy pochwalić się również realizacjami dużych wydarzeń na których poza aspektem artystycznym, zapewnialiśmy elementy scenografii, multimedia, czy elementy wyposażenia. W zależności od potrzeb i skali realizacji zapewniamy pełną obsługę sprzętu przez pracowników technicznych, realizatorów dźwięku, światła oraz wizji.</p>
      </div>
      <Carousel images={images} />
      <div className="section__container" style={{ padding: '100px 15px' }}>
        <p>W naszej ofercie można znaleźć między innymi:</p>
        <br />
        <p><strong>Konstrukcje, scenografia i multimedia</strong></p>
        <ul>
          <li>ponad 100 m2 podestów scenicznych</li>
          <li>dowolne warianty obicia od klasycznych wykładzin po elegancki HIPS</li>
          <li>ponad 200 mb kratownic i konstrukcji w różnych systemach</li>
          <li>możliwość wyprodukowania dowolnych zastawek i zabudów na życzenie klienta</li>
          <li>ekrany bezszwowe</li>
          <li>diody p3 i p5 również outdoor</li>
          <li>projektory i telewizory LCD</li>
        </ul>
        <br/>
        <p><strong>Nagłośnienie</strong></p>
        <ul>
          <li>systemy QSC - KW, KLA</li>
          <li>systemy L’Acoustics - KARA, ARCS, SB18, X12, X8, 5XT</li>
          <li>stoły cyfrowe Behringer, Midas Pro2, Yamaha QL5</li>
          <li>omikrofonowanie kablowe, bezprzewodowe, również nagłowne - Shure, Sennheiser, AKG, EV, Neumann</li>
        </ul>
        <p><strong>Oświetlenie</strong></p>
        <ul>
          <li>Robe Pointe</li>
          <li>Cheuvet Maverick MK2 Spot</li>
          <li>Cheuvet Maverick MK2 Wash</li>
          <li>beam</li>
          <li>point</li>
          <li>led Par</li>
          <li>led Bar</li>
          <li>hazer</li>
          <li>stoły Jands Vista, Dot 2, grandMA2</li>
        </ul>
      </div>
      <div style={{ textAlign: 'center', padding: '30px 0' }}>
        <Button type="yellow" label="Napisz do nas!" mailto="mailto:kontakt@customart.pl"/>
      </div>
      <div style={{paddingTop: 100}} />
    </div>
  )
}

export default Tech;



// WEBPACK FOOTER //
// ./src/pages/technika-estradowa.js